export function getToken() {
    try {
        const token = localStorage.getItem("attendant");
        return token ? JSON.parse(token) : null;
    } catch (err) {
        console.log(err);
        return null;
    }
}

const attendantStorage = {
    getToken
}

export default attendantStorage;